module.exports = __webpack_public_path__ + "img/zapopan-centro.16262394.jpg";